module.exports = __webpack_public_path__ + "img/averageGrossSalaryForThisMonth.c21c47b7.png";